<template>
  <div
    ref="elm"
    class="offcanvas"
    :class="'offcanvas-' + placement"
    tabindex="-1"
    data-bs-backdrop="false"
    data-bs-scroll="true"
    :style="{
      width: placement === 'end' ? width : '',
      height: placement === 'bottom' ? height : '',
    }"
  >
    <div class="offcanvas-header">
      <slot name="header"></slot>
      <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas"></button>
    </div>
    <div class="offcanvas-body pt-0">
      <slot></slot>
    </div>
    <div class="offcanvas-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script setup>
import {onMounted, onUnmounted, ref} from 'vue';
import {setOffcanvas, unsetOffcanvas} from '../composables/useOffcanvas';

const props = defineProps({
    name: String,
    placement: {
        type: String,
        default: 'end'
    },
    onOpen: {
        type: Function,
        default: () => {},
    },
    onClose: {
        type: Function,
        default: () => {},
    },
    width: {
        type: String,
        default: '400px'
    },
    height: {
        type: String,
        default: '300px'
    }
});

const elm = ref();

// オフキャンバスの開閉ごとにbody部分を再レンダリングさせるための変数
const isBodyShown = ref(false);
onMounted(() => {
    setOffcanvas(
        props.name,
        () => {
            isBodyShown.value = true;
            props.onOpen();
        },
        () => {
            isBodyShown.value = false;
            props.onClose();
        },
        elm.value
    );
});

onUnmounted(() => {
    unsetOffcanvas(props.name);
});
</script>

<style lang="scss">
.offcanvas-footer {
    padding: 1rem;
}
</style>
